import React from "react";
import Moment from "moment";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core";

import { Gender } from "types/user";
import { IndexedGames } from "types/game";
import { ScoreCard } from "types/scoreCard";

import HomeIcon from "assets/images/icons/house_100px.png";

type ScoreCardSummaryProps = { scoreCard: ScoreCard };
type MobileStartSheetProps = { gameId: string; games: IndexedGames } & WithStyles;

const ScoreCardSummary = ({ scoreCard }: ScoreCardSummaryProps) => {
  const totalYards = React.useMemo(() => {
    return scoreCard.holesParams?.reduce((total: number, hole) => total + (hole?.yards ?? 0), 0) ?? 0;
  }, [scoreCard.holesParams]);

  const totalPar = React.useMemo(() => {
    return scoreCard.holesParams?.reduce((total: number, hole) => total + (hole?.par ?? 0), 0) ?? 0;
  }, [scoreCard.holesParams]);

  const genderAbbreviation = scoreCard.gender === Gender.Men ? "M" : "L";

  return (
    <span style={{ color: "#5c5c5c" }}>
      <span>Tee ({genderAbbreviation})</span> ({scoreCard.teeColor ?? "N/A"}) , ({scoreCard.courseRating ?? "N/A"}) , (
      {scoreCard.slope ?? "N/A"}){` Yds ${totalYards} Par ${totalPar}`}
    </span>
  );
};

const MobileStartSheet = ({ gameId, games, classes }: MobileStartSheetProps) => {
  const game = games[gameId];
  const gameDate = Moment(game.date).format("DD/MM/YY");

  const scoreCardList = React.useMemo(() => {
    return game.scoreCards ? Object.values(game.scoreCards) : [];
  }, [game.scoreCards]);

  return (
    <div className={classes.root}>
      <div className={classes.summaryContainer}>
        <div>
          <span>{game.competition.name}</span>
          <span style={{ paddingInlineStart: "1rem" }}>{gameDate}</span>
        </div>

        <div>
          <div>
            {scoreCardList.map(scoreCard => (
              <ScoreCardSummary key={`${scoreCard.gender}-${scoreCard.teeColor}`} scoreCard={scoreCard} />
            ))}
            {scoreCardList.length === 0 && <span>No scorecards available for this game.</span>}
          </div>
        </div>

        <span>{game.code}</span>
      </div>
      <div className={classes.iconContainer}>
        <img height="60" width="60" src={HomeIcon} alt="Home Icon" />
        <span>{game.course.club.name}</span>
      </div>
    </div>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "none",
      flexDirection: "row",
      alignItems: "center",
      gap: theme.spacing(1.5),
      padding: theme.spacing(1.5),
      justifyContent: "space-between",
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,

      "@media (max-width: 500px)": {
        display: "flex",
      },
    },
    summaryContainer: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
      gap: theme.spacing(1),
    },
    iconContainer: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  });

export default withStyles(styles)(MobileStartSheet);
